module.exports = __webpack_public_path__ + "static/img/blog-readmore-bg.ffbf361.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-readmore-bg.jpeg
// module id = ytLN
// module chunks = 1